function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34.016 34.016"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.prefix__b{fill:#828a90}')), /*#__PURE__*/React.createElement("title", null, 'e-mail'), /*#__PURE__*/React.createElement("path", {
  fill: "#daf0ed",
  d: "M4.206 7.615h25.71v18.78H4.206z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M4.24 8.265h12.891a.645.645 0 000-1.289H4.24a.649.649 0 000 1.3zM17.131 25.766c-4.343 0-8.692-.071-13.033.082a.551.551 0 000 1.1c4.341.153 8.69.08 13.033.082a.633.633 0 000-1.266z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.917 25.762H17.131a.633.633 0 000 1.266h12.786a.637.637 0 000-1.274zM29.917 8.258a.641.641 0 000-1.282.641.641 0 000 1.282z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M17.131 8.261h12.786a.641.641 0 000-1.282H17.131a.645.645 0 000 1.289z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M24.3 14.239c1.83-1.739 3.81-3.407 5.461-5.319a.547.547 0 00-.773-.773C27 9.7 25.235 11.6 23.4 13.338c-.595.565.307 1.467.9.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M17.761 20.473l6.539-6.234c.594-.567-.306-1.465-.9-.9l-6.552 6.223c-.6.573.311 1.485.912.912zM11.675 13.735c-2.169-2.077-4.253-4.33-6.6-6.2A.548.548 0 004.3 8.3c1.969 2.264 4.307 4.252 6.471 6.331.591.568 1.493-.332.9-.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M17.764 19.565l-6.089-5.83c-.592-.567-1.493.331-.9.9l6.077 5.842c.6.575 1.512-.337.912-.912zM29.281 22.4v4a.633.633 0 001.266 0v-4a.637.637 0 00-1.273 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.281 17.233V22.4a.637.637 0 001.273 0v-5.17a.637.637 0 00-1.273 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M29.277 7.617v9.616a.637.637 0 001.273 0V7.617a.641.641 0 00-1.281 0zM3.569 22.4v4a.633.633 0 001.266 0v-4a.637.637 0 00-1.274 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M3.569 17.233V22.4a.637.637 0 001.274 0v-5.17a.637.637 0 00-1.274 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__b",
  d: "M3.566 7.617v9.616a.637.637 0 001.274 0V7.617a.641.641 0 00-1.281 0z"
}));

export default SvgComponent;